/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  TextArea,
  TextField,
  Button,
  NumberField,
} from '@adobe/react-spectrum';
import Select from 'react-select';
import DateTime from '../../components/Forms/DateTime';
import {
  Actions,
  Section,
  LaunchDateTime,
  customStyles,
  Time,
  Page,
} from '../../components/Forms/DynamicForms/style';
import actionWebInvoke from '../../utils/actionCallUtils';
import actions from '../../config.json';
import OBJCODE from '../../constants';
import getEstDateTime from '../../utils/utils';

function StaticProjectForm(props) {
  const {
    templates,
    selectTemplateAndFetchCategories,
    handlePageChange,
    handleStaticValues,
    values,
    handleDateChange,
    handleTimeChange,
    projectCustomFields,
  } = props;
  const [launchDate, setLaunchDate] = useState(new Date());
  const [launchTime, setLaunchTime] = useState(new Date());
  const [portfolio, setPortfolio] = useState([]);
  const [program, setProgram] = useState([]);
  const [portfolioID, setPortfolioID] = useState('');
  const options = templates.elements?.map(element => {
    return { label: element.name, value: element.ID };
  });
  const optionsPortfolio = portfolio.elements?.map(element => {
    return { label: element.name, value: element.ID };
  });
  const optionsProgram = program.elements?.map(element => {
    return { label: element.name, value: element.ID };
  });

  async function fetchPortfolio() {
    setPortfolio({ ...portfolio, isLoading: true });

    const fields = [];
    const queryParams = { isActive: 'true' };
    const list = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.PORTFOLIO_SEARCH, queryParams, fields },
    );

    setPortfolio({
      ...portfolio,
      elements: list,
      isLoading: false,
    });
  }

  async function fetchProgram() {
    setProgram({ ...program, isLoading: true });

    const fields = [];
    const queryParams = { portfolioID };
    const list = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.PROGRAM_SEARCH, queryParams, fields },
    );

    setProgram({
      ...program,
      elements: list,
      isLoading: false,
    });
  }

  useEffect(() => {
    fetchPortfolio();
  }, []);

  useEffect(() => {
    if (portfolioID) {
      fetchProgram();
    }
  }, [portfolioID]);

  return (
    <>
      <Section>
        <TextField
          label="Project"
          placeholder="Title that describes project"
          width="461px"
          value={values.name || ''}
          onInput={event => {
            const {
              target: { value },
            } = event;
            handleStaticValues('name', value);
          }}
        />
      </Section>
      <div style={{ marginTop: '20px' }}>
        <label className="_spectrum-FieldLabel_36b9b">Project template</label>
        <Select
          styles={customStyles}
          name="template"
          isSearchable={false}
          classNamePrefix="react-select"
          placeholder={
            values.select || 'Choose a project you want to get started on'
          }
          onChange={data => {
            selectTemplateAndFetchCategories(data.value);
          }}
          options={options}
          className="basic-multi-select"
        />
      </div>
      <div style={{ marginTop: '20px' }}>
        <label className="_spectrum-FieldLabel_36b9b">Portfolio</label>
        <Select
          styles={customStyles}
          name="portfolio"
          isSearchable={false}
          classNamePrefix="react-select"
          placeholder={values.select || 'Choose Portfolio'}
          onChange={data => {
            setPortfolioID(data.value);
            handleStaticValues('portfolioID', data.value);
          }}
          options={optionsPortfolio}
          className="basic-multi-select"
        />
      </div>
      <div style={{ marginTop: '20px' }}>
        <label className="_spectrum-FieldLabel_36b9b">Program</label>
        <Select
          styles={customStyles}
          name="program"
          isSearchable={false}
          classNamePrefix="react-select"
          placeholder={values.select || 'Choose Program'}
          onChange={data => handleStaticValues('programID', data.value)}
          options={optionsProgram}
          className="basic-multi-select"
        />
      </div>
      <LaunchDateTime>
        <DateTime
          label="Launch date"
          dateFormat="MM/dd/YYY"
          onChange={date => {
            setLaunchDate(date);
            handleDateChange('plannedCompletionDate', getEstDateTime(date));
          }}
          minDate={new Date()}
          showDisabledMonthNavigation
          value={launchDate}
          selected={launchDate}
          placeholderText="MM/dd/YYY"
        />
        <Time>
          <DateTime
            label="Launch time"
            selected={launchTime}
            onChange={date => {
              setLaunchTime(date);
              handleTimeChange('plannedCompletionDate', getEstDateTime(date));
            }}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={5}
            timeCaption="Time"
            dateFormat="h:mm aa"
          />
        </Time>
      </LaunchDateTime>
      <Section>
        <NumberField
          label="Budget"
          defaultValue={0}
          hideStepper
          onChange={value => handleStaticValues('budget', value)}
          formatOptions={{
            style: 'currency',
            currency: 'USD',
            currencyDisplay: 'symbol',
            currencySign: 'accounting',
          }}
          width="195px"
        />
      </Section>
      <Section>
        <TextArea
          width="739px"
          height="143px"
          label="Project description and links"
          value={values.description || ''}
          onInput={event => {
            const {
              target: { value },
            } = event;
            handleStaticValues('description', value);
          }}
          placeholder="Description of task"
        />
      </Section>
      <Section>
        <Actions>
          <Button
            variant="cta"
            onPress={handlePageChange}
            isDisabled={!templates.selected}
          >
            Next
          </Button>
          {projectCustomFields?.length === 0 ? (
            <Page>Page 1 of 2</Page>
          ) : (
            <Page>Page 1 of 3</Page>
          )}
        </Actions>
      </Section>
    </>
  );
}

export default StaticProjectForm;
